// Account
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const UPDATE_ROUNDTABLES = 'UPDATE_ROUNDTABLES';
export const SET_ACCOUNT_LOADING = 'SET_ACCOUNT_LOADING';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const UPDATE_USER_SCHOOL = 'UPDATE_USER_SCHOOL';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const MY_RT_IDENTITY = 'MY_RT_IDENTITY';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const MARK_NOTIFICATIONS_AS_READ = 'MARK_NOTIFICATIONS_AS_READ';
export const UPGRADE_USER = 'UPGRADE_USER';
export const UPDATE_ONBOARDING = 'UPDATE_ONBOARDING';
export const UPDATE_GOOGLE_INTEGRATION = 'UPDATE_GOOGLE_INTEGRATION';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const CHANGE_AVATAR = 'CHANGE_AVATAR';
export const CHANGE_NAME = 'CHANGE_NAME';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';

// Courses
export const CREATE_RT = 'CREATE_RT';
export const DELETE_RT = 'DELETE_RT';
export const DELETE_DRAFT = 'DELETE_DRAFT';
export const SET_COURSES = 'SET_COURSES';
export const SET_NEW_COURSE = 'SET_NEW_COURSE';
export const SET_COURSE_LOADING = 'SET_COURSE_LOADING';
export const SET_COURSE_DETAIL = 'SET_COURSE_DETAIL';
export const UPDATE_COURSE_DETAIL = 'UPDATE_COURSE_DETAIL';
export const DELETE_USER_FROM_COURSE = 'DELETE_USER_FROM_COURSE';
export const DELETE_COURSE = 'DELETE_COURSE';
export const ARCHIVE_COURSE = 'ARCHIVE_COURSE';
export const PUBLISH_RT_IN_COURSE_STATE = 'PUBLISH_RT_IN_COURSE_STATE';
export const PUBLISH_LD_IN_COURSE_STATE = 'PUBLISH_LD_IN_COURSE_STATE';
export const EDIT_ACTIVITY_IN_COURSE_STATE = 'EDIT_ACTIVITY_IN_COURSE_STATE';
export const SET_NEW_LIVE_DISCUSSION = 'SET_NEW_LIVE_DISCUSSION';
export const SET_NEW_ONLINE_ROUNDTABLE = 'SET_NEW_ONLINE_ROUNDTABLE';
export const ADD_STUDENT_TO_COURSE = 'ADD_STUDENT_TO_COURSE';
export const REMOVE_STUDENTS_FROM_COURSE = 'REMOVE_STUDENTS_FROM_COURSE';
export const CHANGE_FULL_SCREEN_ON_COURSE_LAYOUT =
  'CHANGE_FULL_SCREEN_ON_COURSE_LAYOUT';
export const SET_DASHBOARD_ROLE = 'SET_DASHBOARD_ROLE';
export const SHOW_SLIDING_HIDDEN_ROUNDTABLE_LIST =
  'SHOW_SLIDING_HIDDEN_ROUNDTABLE_LIST';
export const UPDATE_SAVED_FEEDBACK_ONLINE_DISCUSSION =
  'UPDATE_SAVED_FEEDBACK_ONLINE_DISCUSSION';
export const UPDATE_SAVED_FEEDBACK_LIVE_DISCUSSION =
  'UPDATE_SAVED_FEEDBACK_LIVE_DISCUSSION';

export const IMPORT_SAVED_FEEDBACK_ONLINE_DISCUSSION =
  'IMPORT_SAVED_FEEDBACK_ONLINE_DISCUSSION';
export const IMPORT_SAVED_FEEDBACK_LIVE_DISCUSSION =
  'IMPORT_SAVED_FEEDBACK_LIVE_DISCUSSION';
export const DELETE_SAVED_FEEDBACK_ONLINE_DISCUSSION =
  'DELETE_SAVED_FEEDBACK_ONLINE_DISCUSSION';
export const DELETE_SAVED_FEEDBACK_LIVE_DISCUSSION =
  'DELETE_SAVED_FEEDBACK_LIVE_DISCUSSION';
export const ENDED_RT_IN_COURSE_STATE = 'ENDED_RT_IN_COURSE_STATE';
export const SYNC_COURSES = 'SYNC_COURSES';

export const UPDATE_RT_END_DATE_IN_COURSE_STATE =
  'UPDATE_RT_END_DATE_IN_COURSE_STATE';
export const ACTIVE_RT_IN_COURSE_STATE = 'ACTIVE_RT_IN_COURSE_STATE';
export const TOOGLE_COURSE_CHAT = 'TOOGLE_COURSE_CHAT';
export const SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE';
export const DELETE_CHAT_MESSAGE = 'DELETE_CHAT_MESSAGE';
export const DELETE_ALL_CHAT_MESSAGES = 'DELETE_ALL_CHAT_MESSAGES';
export const READ_COURSE_MESSAGES = 'READ_COURSE_MESSAGES';
export const UPDATE_COURSES_LIST = 'UPDATE_COURSES_LIST';
export const UPDATE_SEQUENCE_DETAILS = 'UPDATE_SEQUENCE_DETAILS';
export const SET_INSTRUCTOR_COURSES = 'SET_INSTRUCTOR_COURSES';
export const SET_PARTICIPANT_COURSES = 'SET_PARTICIPANT_COURSES';


// Roundtables
export const PUBLISH_RT = 'PUBLISH_RT';
export const UPDATE_RT_DETAILS = 'UPDATE_RT_DETAILS';
export const REPLACE_SUBMISSION = 'REPLACE_SUBMISSION';
export const SET_RT_SAVING = 'SET_RT_SAVING';
export const ADD_SUBMISSION_COMMENT = 'ADD_SUBMISSION_COMMENT';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const UPDATE_SUBMISSION_FLAG = 'UPDATE_SUBMISSION_FLAG';
export const UPDATE_COMMENT_FLAG = 'UPDATE_COMMENT_FLAG';
export const UPDATE_REPLY_FLAG = 'UPDATE_REPLY_FLAG';
export const SET_LOADING_SAVING_RT = 'SET_LOADING_SAVING_RT';
export const JOIN_STUDENTS = 'JOIN_STUDENTS';
export const REMOVE_STUDENTS_RT = 'REMOVE_STUDENTS_RT';
export const REMOVE_STUDENT_RT = 'REMOVE_STUDENT_RT';
export const UPDATE_STAR_COUNT = 'UPDATE_STAR_COUNT';
export const UPDATE_STAR_COUNT_SUMMARY = 'UPDATE_STAR_COUNT_SUMMARY';
export const SET_ONLINE_ROUNDTABLES_LOADING = 'SET_ONLINE_ROUNDTABLES_LOADING';
export const UPDATE_SUBMISSION_SEEN_BY = 'UPDATE_SUBMISSION_SEEN_BY';
export const EDIT_SUBMISSION_CONTENT = 'EDIT_SUBMISSION_CONTENT';
export const UPDATE_SUBMISSION_SPREAD = 'UPDATE_SUBMISSION_SPREAD';
export const TOGGLE_REVEAL_NAMES = 'TOGGLE_REVEAL_NAMES';
export const ADD_SUBMISSION_POINT = 'ADD_SUBMISSION_POINT';
export const REMOVE_SUBMISSION_POINT = 'REMOVE_SUBMISSION_POINT';
export const LOADING_SUBMISSION_COMMENTS = 'LOADING_SUBMISSION_COMMENTS';
export const UPDATE_SUBMISSION_ASSESSMENT = 'UPDATE_SUBMISSION_ASSESSMENT';
export const UPDATE_SUBMISSION_DRAFT_ASSESSMENT = 'UPDATE_SUBMISSION_DRAFT_ASSESSMENT';
export const ADD_CRITERIA_ASSESSMENT_POINT = 'ADD_CRITERIA_ASSESSMENT_POINT';
export const CHANGE_CRITERIA_ASSESSMENT_POINT = 'CHANGE_CRITERIA_ASSESSMENT_POINT';
export const CHANGE_CRITERIA_FEEDBACK = 'CHANGE_CRITERIA_FEEDBACK';
export const UPDATE_ROUNDTABLE_KEYWORDS = 'UPDATE_ROUNDTABLE_KEYWORDS';
export const UPDATE_ROUNDTABLE_PLAGIARISM_SCORES = 'UPDATE_ROUNDTABLE_PLAGIARISM_SCORES';
export const ACTIVE_RT = 'ACTIVE_RT';
export const RESET_ROUNDTABLE_GRADES = 'RESET_ROUNDTABLE_GRADES';
export const SET_RECENT_ROUNDTABLES = 'SET_RECENT_ROUNDTABLES';
export const DELETE_RECENT_RT = 'DELETE_RECENT_RT';
export const UPDATE_COURSE_INTEGRATIONS = 'UPDATE_COURSE_INTEGRATIONS';
export const SET_PROVIDERS = 'SET_PROVIDERS';
export const UPDATE_PROVIDERS = 'UPDATE_PROVIDERS';
export const MARK_ROUNDTABLE_AS_OPENED = 'MARK_ROUNDTABLE_AS_OPENED';
export const UPDATE_RECENT_ROUNDTABLES = 'UPDATE_RECENT_ROUNDTABLES';
export const INCREMENT_SUBMISSION_COMMENT_COUNT = 'INCREMENT_SUBMISSION_COMMENT_COUNT';
export const SET_GENIE_RECAP = 'SET_GENIE_RECAP';
export const UPDATE_GENIE_RECAP = 'UPDATE_GENIE_RECAP';
export const SET_GENIE_RECAP_COMMENTS = 'SET_GENIE_RECAP_COMMENTS';
export const ADD_RECAP_COMMENT = 'ADD_RECAP_COMMENT';
export const INCREMENT_RECAP_COMMENT_COUNT = 'INCREMENT_RECAP_COMMENT_COUNT';
export const ENABLE_ANNONYMOUS = 'ENABLE_ANNONYMOUS';
// Grading

export const POST_CLASS_SUMMARY = 'POST_CLASS_SUMMARY';
export const POST_SUBMISSION_SUMMARY = 'POST_SUBMISSION_SUMMARY';
// Unused mutations and funcitonst that call it (i think)
export const POST_DRAFT_EVALUATION = 'POST_DRAFT_EVALUATION';
export const POST_EVALUATION = 'POST_EVALUATION';
export const LOADING_GRADES = 'LOADING_GRADES';

// Auth
export const CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION';
export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';

// live discussions
export const UPDATE_LD_DETAILS = 'UPDATE_LD_DETAILS';
export const UPDATE_LIVE_DISCUSSION = 'UPDATE_LIVE_DISCUSSION';
export const UPDATE_LIVE_DISCUSSION_SPREAD = 'UPDATE_LIVE_DISCUSSION_SPREAD';
export const PUBLISH_LIVE_DISCUSSION = 'PUBLISH_LIVE_DISCUSSION';
export const START_LIVE_DISCUSSION = 'START_LIVE_DISCUSSION';
export const ADD_PARTICIPATION = 'ADD_PARTICIPATION';
export const UPDATE_PARTICIPATION = 'UPDATE_PARTICIPATION';
export const UPDATE_PARTICIPATION_SPREAD = 'UPDATE_PARTICIPATION_SPREAD';
export const NEW_TURN = 'NEW_TURN';
export const UPDATE_PARTICIPATION_TURN_COUNT =
  'UPDATE_PARTICIPATION_TURN_COUNT';
export const PAUSE_LIVE_DISCUSSION = 'PAUSE_LIVE_DISCUSSION';
export const UPDATE_TURNS_POSITION = 'UPDATE_TURNS_POSITION';
export const END_LIVE_DISCUSSION = 'END_LIVE_DISCUSSION';
export const RESTART_LIVE_DISCUSSION = 'RESTART_LIVE_DISCUSSION';
export const POST_PARTICIPATION_SUMMARY = 'POST_PARTICIPATION_SUMMARY';
export const UPDATE_PARTICIPATION_SUMMARY = 'UPDATE_PARTICIPATION_SUMMARY';
export const POST_CLASS_SUMMARY_LD = 'POST_CLASS_SUMMARY_LD';
export const LOADING_LIVE_DISCUSSION = 'LOADING_LIVE_DISCUSSION';
export const DELETE_DISCUSSION = 'DELETE_DISCUSSION';
export const REMOVE_STUDENT_LD = 'REMOVE_STUDENT_LD';
export const REMOVE_STUDENTS_LD = 'REMOVE_STUDENTS_LD';
export const POST_DRAFT_FEEDBACK_FOR_STUDENT = 'POST_DRAFT_FEEDBACK_FOR_STUDENT';
export const POST_FEEDBACK_FOR_STUDENT = 'POST_FEEDBACK_FOR_STUDENT';
export const UPDATE_FEEDBACK_FOR_STUDENT_LD = 'UPDATE_FEEDBACK_FOR_STUDENT_LD';
export const UPDATE_POINTS_SETTINGS_LIVE_DISCUSSION =
  'UPDATE_POINTS_SETTINGS_LIVE_DISCUSSION';
export const UPDATE_STUDENT_POINT_SETTINGS = 'UPDATE_STUDENT_POINT_SETTINGS';
export const UPDATE_HAND_RAISES = 'UPDATE_HAND_RAISES';
export const LD_GIVE_POINT = 'LD_GIVE_POINT';
export const LD_REMOVE_POINT = 'LD_REMOVE_POINT';
export const SOCKET_UPDATE_QUEUE = 'SOCKET_UPDATE_QUEUE';
export const UPDATE_NUDGES = 'UPDATE_NUDGES';
export const MODERATOR_CHOSEN = 'MODERATOR_CHOSEN';
export const RESET_MODERATOR = 'RESET_MODERATOR';
export const TOGGLE_QUEUE = 'TOGGLE_QUEUE';
export const UPDATE_DRAFT_STUDENT_ASSESSMENTS = 'UPDATE_DRAFT_STUDENT_ASSESSMENTS';
export const UPDATE_STUDENT_ASSESSMENTS = 'UPDATE_STUDENT_ASSESSMENTS';
export const USER_ENTERED_SUMMARY_OVERLAY = 'USER_ENTERED_SUMMARY_OVERLAY';
export const UPDATE_SPEAKER_COUNT = 'UPDATE_SPEAKER_COUNT';
export const DELETE_GENIE_RECAP = 'DELETE_GENIE_RECAP';

// rounds in LD
export const UPDATE_STUDENT_NOTES_LD = 'UPDATE_STUDENT_NOTES_LD';
export const UPDATE_PRIVATE_TEACHER_NOTES_LD = 'UPDATE_PRIVATE_TEACHER_NOTES_LD';
export const UPDATE_LIVE_DISCUSSION_CIRCLE = 'UPDATE_LIVE_DISCUSSION_CIRCLE';
export const MARK_LIVE_DISCUSSION_AS_PUBLISHED = 'MARK_LIVE_DISCUSSION_AS_PUBLISHED';
export const MARK_ONLINE_ROUNDTABLE_AS_PUBLISHED = 'MARK_ONLINE_ROUNDTABLE_AS_PUBLISHED';
export const UPDATE_STUDENT_NUDGE = 'UPDATE_STUDENT_NUDGE';


// turns
export const UPDATE_TURN = 'UPDATE_TURN';

// polls
export const SET_POLL = 'SET_POLL';
export const SET_VOTE = 'SET_VOTE';
export const DELETE_POLL = 'DELETE_POLL';
export const UPDATE_LIVE_DISCUSSION_POLLS = 'UPDATE_LIVE_DISCUSSION_POLLS';

// subscription
export const UPDATE_SUBSCRIPTION_TO_COURSE = 'UPDATE_SUBSCRIPTION_TO_COURSE';

// ANALYTICS_EVENT
export const ANALYTICS_EVENT = 'ANALYTICS_EVENT';

//ADMIN PORTAL
export const SET_SCHOOL = 'SET_SCHOOL';
export const UPDATE_SCHOOL_INVITE = 'UPDATE_SCHOOL_INVITE';
export const UPDATE_SCHOOL_DETAILS = 'UPDATE_SCHOOL_DETAILS';
export const ADD_NEW_SUGGESTION = 'ADD_NEW_SUGGESTION';
export const EDIT_SUGGESTION = 'EDIT_SUGGESTION';
export const DELETE_SUGGESTION = 'DELETE_SUGGESTION';
export const SET_SUGGESTIONS = 'SET_SUGGESTIONS';
export const CLEAN_NEW_SUGGESTIONS = 'CLEAN_NEW_SUGGESTIONS';
//audio live
export const TOGGLE_DISCUSSION_AUDIO = 'TOGGLE_DISCUSSION_AUDIO';
export const TOGGLE_PARTICIPATION_AUDIO = 'TOGGLE_PARTICIPATION_AUDIO';
export const TOGGLE_PARTICIPATION_VIDEO = 'TOGGLE_PARTICIPATION_VIDEO';
export const VIDEO_OFF_MUTE_PARTICIPATIONS = 'VIDEO_OFF_MUTE_PARTICIPATIONS';
export const MUTE_PARTICIPATIONS = 'MUTE_PARTICIPATIONS';
export const START_AUDIO_CONNECTION = 'START_AUDIO_CONNECTION';
export const END_AUDIO_CONNECTION = 'END_AUDIO_CONNECTION';
export const TEACHER_TAP_IN = 'TEACHER_TAP_IN';
export const TEACHER_TAP_OUT = 'TEACHER_TAP_OUT';
export const UPDATE_VERBAL_RECAP = 'UPDATE_VERBAL_RECAP';
export const SET_VERBAL_TRANSCRIPTION = 'SET_VERBAL_TRANSCRIPTION';
export const ADD_ACTIVITY_PASSES = 'ADD_ACTIVITY_PASSES';




// WEBPACK FOOTER //
// ./src/app/store/mutation-types.js